import { searchIncomesBrowse } from "../../../api/accounts.service";
import { useAccountTypeBrowse } from "../../../hooks/useAccountTypeBrowse";
import { INCOME_ACCOUNT_TYPE } from "./incomes.constants";

export function useIncomesBrowse() {
  return useAccountTypeBrowse({
    accountType: INCOME_ACCOUNT_TYPE,
    searchBrowse: searchIncomesBrowse,
  });
}
